import React, { Component } from "react";
import PropTypes from "prop-types";
import { browserHistory } from "react-router";
import groupBy from "lodash/groupBy";
import partial from "lodash/partial";
import { getSubCategory } from "common/ducks/categories";
import { getTimeLeftLabel } from "common/utils";
import Money from "common/components/money";
import ProjectLink from "common/containers/project_link";
import Feedback from "common/containers/project_feedback";

export default class WatchlistProjects extends Component {
  constructor(props) {
    super(props);

    this.unwatch = this.unwatch.bind(this);
  }

  unwatch(id) {
    /* unwatch and fetch updated list */
    this.props
      .unwatch(id)
      .then(() => browserHistory.push("/your-projects/creative/watchlist/"));
  }

  renderSubcategory(id, projects) {
    const { categories } = this.props;
    const subcat = getSubCategory(categories, parseInt(id));

    return (
      <table className="table table-default" key={id}>
        <thead>
          <tr>
            <td className="title" width="40%">
              <h4>{subcat ? subcat.name : ""}</h4>
            </td>
            <td>Time Left</td>
            <td>Award</td>
            <td className="hide-for-small-only">Entries</td>
            <td className="hide-for-small-only">Feedback</td>
            <td />
          </tr>
        </thead>
        <tbody>
          {projects.map((project) => (
            <tr key={project.id}>
              <td className="title" width="40%">
                <ProjectLink project={project} />
              </td>
              <td className="center bold">
                {getTimeLeftLabel(project.deadline)}
              </td>
              <td className="center bold">
                <Money value={project.total_awards_and_tips} />
              </td>
              <td className="center bold hide-for-small-only">
                {project.entry_count}
              </td>
              <td className="center bold hide-for-small-only">
                <Feedback project={project} />
              </td>
              <td className="unwatch">
                <button
                  className="fa fa-times-circle"
                  onClick={partial(this.unwatch, project.id)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    const { items } = this.props;
    const groups = groupBy(items, (i) => i.subcategory);

    return (
      <div className="watchlist">
        {Object.keys(groups).map((subcatId) =>
          this.renderSubcategory(subcatId, groups[subcatId])
        )}
      </div>
    );
  }
}

WatchlistProjects.propTypes = {
  items: PropTypes.array.isRequired,
  categories: PropTypes.object.isRequired,
  unwatch: PropTypes.func.isRequired,
};
